import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { EmailTemplateProvider, useEmailTemplateStore } from '../store';

const EmailTemplateForm = () => {
  const { id, typeTemplate } = useParams()
  const { useLoad, collection: { item, useSubmit } } = useEmailTemplateStore()
  const { handleSuccess, handleError } = useAppAlert()

  const handleSubmit = useSubmit()

  useLoad(id, typeTemplate)

  const handleSidebarClose = useCallback(() => {
    history.push('/settings/email-templates')
  }, [])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      handleSidebarClose()
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Email Template ${message}.`)
    } catch {
      handleError('Error', 'Email Template was not saved.')
    }
  }, [handleSidebarClose, handleSubmit, handleSuccess, handleError])

  if (!item) {
    return null
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleSidebarClose() }}
      title={item.id ? 'Edit Email Template' : 'Add Email Template'}
    >
      <Helmet title="Email Template" />
      <Form data={item} onSubmit={handleSubmitAndClose} onCancel={handleSidebarClose} />
    </DefaultSheet>
  </>
}

export default function EmailTemplateFormLayout() {
  return <EmailTemplateProvider>
    <EmailTemplateForm />
  </EmailTemplateProvider>
}
